
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-x-end-v6-features",
      function () {
        return require("private-next-pages/blog/mui-x-end-v6-features.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-x-end-v6-features"])
      });
    }
  